module.exports = "/images/icon_social_insta_color.png?9bbb9ab0754ab50adea338e8fd06673f";